export const css = {
	root: '_2_reDxm9',
	' _key': 'ascm-theme/ascm/variants/cpim2024ss'
};

export default css;
